export const root = "r1cw3vg6";
export const checkbox = "cqtgiol";
export const label = "lnr0bbt";
export const inner = "i1ahfgcc";
export const toggle = "t1ru48pu";
export const checkedInner = "cqibjxb";
export const checkedToggle = "c1cjy0xt";
export const disabled = "d19thj1q";
export const small = "s874y8l";

require("./style.linaria.module.css!=!../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js?cacheProvider=!./style.ts");